import { bl_fi_fixed_asset_register_import_file_helper_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class AssetRegisterImportFileHelperContainerModel extends BaseContainerModel {
  bl_fi_fixed_asset_register_import_file_helper: bl_fi_fixed_asset_register_import_file_helper_RowClass = new bl_fi_fixed_asset_register_import_file_helper_RowClass();
}

